export default __webpack_public_path__ + "static/media/ldo_ADJ_BIAS_EN_nCff.1263a50e.svg";